import {toURL} from '@homeaway/search-url-parser';

export const getPrefix = () => window.location.pathname.split('/')[1] || 'd';

export const buildSerpUrl = ({basePath = '', host: hostname, params}) => toURL(params, {basePath, hostname});

export function urlPathToParts(pathname, prefix, basePath) {
    /* This regex will end up looking like one of these two below, depending on whether `basePath` exists:
       /^(?<prefix>/prefix){0,1}(?<actualPath>.*)$/
       /^(?<basePath>basePath){0,1}(?<prefix>/prefix){0,1}(?<actualPath>.*)$/

       Where `basePath` and `prefix` are the values present in their respective variables.

       E.g call and object returned.
       urlPathToParts('/jp-JP/vacation-rentals/40/austin', 'vacation-rentals', '/jp-JP');
       // returns
       {actualPath: '/40/austin', basePath: '/jp-JP', prefix: '/vacation-rentals'}
    */

    const reBasePath = basePath ? `(?<basePath>${basePath}){0,1}` : '';

    const re = new RegExp(`^${reBasePath}(?<prefix>\/${prefix}){0,1}(?<actualPath>.*)$`);

    return re.exec(decodeURIComponent(pathname)).groups;
}
